import { css } from "@emotion/react";
import { kitText } from "../../styles";
import { CHECKBOX_FILL_VAR } from "./constants";

export const styles = {
  wrapper: css`
    ${CHECKBOX_FILL_VAR}: var(--color-background-primary);
    position: relative;
    display: flex;
    gap: var(--spacing-8);
    cursor: pointer;
    ${kitText.variant.body}

    &:has(input[type="checkbox"]:disabled) {
      cursor: default;
    }

    input[type="checkbox"] {
      position: absolute;
      margin: 0;
      width: 1rem;
      height: 1rem;
      cursor: inherit;
      appearance: none;
    }

    input[type="checkbox"] {
      + div {
        display: inline-flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        width: 1rem;
        height: 1rem;
        padding: var(--spacing-2);
        border: 1px solid var(--color-border-primary);
        border-radius: var(--border-radii-sm);
        user-select: none;
      }

      &:hover + div {
        border-color: var(--color-splash-secondary);
      }

      &:active + div,
      &:focus + div {
        border-color: var(--color-splash-tertiary);
      }

      &:disabled + div {
        ${CHECKBOX_FILL_VAR}: var(--color-border-primary);
        background-color: var(--color-background-tertiary);
        border-color: var(--color-border-secondary);
      }

      &:focus-visible + div {
        outline: 2px solid var(--color-primary);
        outline-offset: 2px;
      }

      &:checked,
      &:indeterminate {
        &:not(:disabled) {
          + div {
            background-color: var(--color-splash-primary);
            border-color: var(--color-splash-primary);
          }

          &:hover + div {
            background-color: var(--color-splash-secondary);
          }

          &:active + div {
            background-color: var(--color-splash-tertiary);
          }
        }
      }
    }
  `,
  label: css`
    display: inline-flex;
    gap: var(--spacing-4);
  `,
  ellipses: css`
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  error: css`
    input[type="checkbox"] + div {
      border-color: var(--color-danger);
    }

    input[type="checkbox"]:checked + div,
    input[type="checkbox"]:indeterminate + div {
      border: 1px solid var(--color-danger);
    }
  `
};
